import type { FeedbackCategory } from "../../data/feedbackData";

// TODO: Review and refine Dutch translations

export const PILLAR_FEEDBACKS_NL: Record<
  number,
  Record<FeedbackCategory, string>
> = {
  1: {
    bas: "Uw marketingstrategie vaart blind, wat de verdienste van het avontuur heeft, maar zelden van de ROI. Laten we zien of uw merk het voortouw heeft genomen.",
    mid: "De strategische basis is er, met enkele grijze zones. Laten we zien of uw merk zich daarop steunt, of parallel werkt.",
    haut: "Uw strategie is gestructureerder dan die van de meeste B2B-bedrijven. De druk ligt nu op de uitvoering: volgt uw merk?",
  },
  2: {
    bas: "Uw merk en tools doen nog niet het werk voor u. Elke klantinteractie kost meer moeite dan ze zou moeten.",
    mid: "Uw merk heeft een basis, zonder al een groeimotor te zijn. Het potentieel is er, de consistentie ontbreekt.",
    haut: "Uw merk is een actief. Coherente identiteit, tools op zijn plaats, elke marketingactie reikt verder.",
  },
  3: {
    bas: "Qua content en zichtbaarheid is het windstil. Uw concurrenten vangen de aandacht die u niet betwist.",
    mid: "Content en zichtbaarheid zijn er, maar nog niet het ritme of de precisie die aandacht omzetten in pipeline.",
    haut: "Uw contentmachine draait. Regelmatige productie, actieve distributie, gecoördineerde aanwezigheid — het is een motor.",
  },
  4: {
    bas: "Qua AI en tools begint u van ver. Maar het is ook de pijler die het snelst vooruitgaat als men er echt aan begint.",
    mid: "Enkele tools, enkele AI-toepassingen, maar nog geen systeem. U hebt de inzet begrepen, het structureren is nog een stap.",
    haut: "Uw stack is op zijn plaats en AI werkt voor u. Het is een concurrentievoordeel dat weinig B2B-teams al beheersen.",
  },
};

type Cat = FeedbackCategory;

export const CROSS_P2_NL: Record<Cat, Record<Cat, string>> = {
  bas: {
    bas: "Noch de strategie noch het merk dragen uw marketing — het gaat vooruit op kracht. Dat is gebruikelijk in B2B, en het is het terrein waar de snelle winsten het meest zichtbaar zijn.",
    mid: "Uw merk loopt voor op uw strategie. De fundamenten zijn er, het vliegplan ontbreekt om ze te benutten.",
    haut: "Uw merk is duidelijk rijper dan uw strategie. Mooie etalage, maar zonder circulatieplan bewonderen bezoekers zonder noodzakelijk tot actie over te gaan.",
  },
  mid: {
    bas: "Uw strategie is verder dan uw merk. U weet waar u heen wilt, maar uw imago en tools volgen de beweging nog niet.",
    mid: "Strategie en merk evolueren op hetzelfde tempo, op evenwichtige wijze. Het is stabiel — laten we zien of uw content het verschil maakt.",
    haut: "Uw merk is sterker dan uw strategie. De middelen om uit te voeren zijn er, het verfijnen van de richting ontbreekt nog.",
  },
  haut: {
    bas: "Sterk contrast: de strategie is solide, het merk volgt niet. Zoals een uitstekend product in een verpakking die het geen recht doet.",
    mid: "De strategie leidt, het merk volgt. Het verschil is niet dramatisch: enkele aanpassingen aan het imago en de tools kunnen veel deblokkeren.",
    haut: "Strategie en merk zijn afgestemd: zeldzame combinatie in B2B. De druk ligt nu op uw content en zichtbaarheid.",
  },
};

export const CROSS_P3_UNIFORME_NL: Record<FeedbackCategory, string> = {
  bas: "Drie pijlers, dezelfde vaststelling: marketing is in aanbouw. Paradoxaal genoeg is dit een goed vertrekpunt: geen onevenwichtigheid te corrigeren, gewoon een basis op te bouwen. Laatste thema komt eraan.",
  mid: "Drie pijlers op hetzelfde intermediaire niveau. Geen gapend gat, geen onderscheidende kracht. Uw marketing werkt, maar onderscheidt zich nog niet. Laatste thema komt eraan.",
  haut: "Strategie, merk en content: allemaal boven het B2B-gemiddelde. Dat is zeldzaam. Laten we zien of uw tools en AI-gebruik het gebouw voltooien.",
};

export const CROSS_P3_EN_RETRAIT_NL: Record<
  "strategie" | "marque" | "contenu",
  string
> = {
  strategie:
    "De uitvoering (merk, content) loopt voor op de strategie. Frequent patroon: men doet eerst, structureert daarna. Het risico is veel activiteit zonder convergentie.",
  marque:
    "Strategie en content evolueren, maar de infrastructuur (merk, tools, website) volgt niet. Klassieke bottleneck in B2B: alles lijkt te werken, niets schaalt.",
  contenu:
    "Strategie en merk houden stand, maar de zichtbaarheid volgt niet. Uw marketing bestaat intern maar is bijna onzichtbaar van buiten. Goed nieuws: dit is de pijler die het snelst evolueert.",
};

export const CROSS_P3_EN_AVANCE_NL: Record<
  "strategie" | "marque" | "contenu",
  string
> = {
  strategie:
    "Strategie is uw sterk punt, de uitvoering loopt achter. Heldere visie, beperkte of slecht afgestemde middelen. Het laatste thema zal zeggen of de tools de kloof kunnen overbruggen.",
  marque:
    "Uw infrastructuur (merk, tools, website) loopt voor op de rest. De fundamenten zijn solide, de strategische richting of content om ze te benutten ontbreekt.",
  contenu:
    "Uw content leidt de dans, maar noch de strategie noch de infrastructuur staat op hetzelfde niveau. Zichtbaar zijn is goed, maar de aandacht moet nog worden omgezet.",
};
